import type { RotasDoModulo } from '@/app/rotas';

import {
  CancellationsPage,
  ClaimsPage,
  EndorsementsPage,
  RenewalsPage,
} from './AftercarePages';
import { EndorsementTypePage } from './EndorsementTypePage';
import { EndorsementWizard } from './EndorsementWizard';

/**
 * Pos-emissao: endossos, cancelamentos, renovacoes e sinistros. A selecao do tipo de
 * endosso e o assistente (P-END-1) ficam fora do menu, sob a apolice que recebe o
 * endosso.
 */
export const rotas: RotasDoModulo = {
  menu: {
    '/endossos': EndorsementsPage,
    '/cancelamentos': CancellationsPage,
    '/renovacoes': RenewalsPage,
    '/sinistros': ClaimsPage,
  },
  moldura: [
    { path: '/apolices/:policyId/endosso', element: <EndorsementTypePage /> },
    {
      path: '/apolices/:policyId/endosso/:tipo/:subtypeId',
      element: <EndorsementWizard />,
    },
  ],
};
